import PageNotFound from "@/views/PageNotFound.vue"

const lang = localStorage.language || 'tw'

const routes = [
  {
    path: "/:lang/404",
    name: "PageNotFound",
    component: PageNotFound,
    meta: {
      title: "不存在的頁面",
      requireAuth: false,
      back2Auth: false,
      auth: 0
    }
  },
  {
    path: "/:lang/*",
    redirect: "/:lang/404",
    hidden: true
  },
  {
    path: "/",
    redirect: "/" + lang + "/login",
    hidden: true
  }
]

export default routes
